import api from './client';
import ApiError from './error';

const AuthService = {
  async authenticateWithEmail({
    email, password, deviceUUID, location,
  }) {
    try {
      const client = await api.getClient();
      return client.createBearerToken(null, {
        device_uuid: deviceUUID,
        location,
        email,
        password,
      });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async authenticateWithPhone({
    requestUUID, phoneNumber, message, deviceUUID, location,
  }) {
    try {
      const client = await api.getClient();

      if (!phoneNumber.startsWith('354')) {
        phoneNumber = `354${phoneNumber}`;
      }

      if (phoneNumber.charAt(0) !== '+') {
        phoneNumber = `+${phoneNumber}`;
      }

      return client.initAudkenniAuthenticate(requestUUID, {
        device_uuid: deviceUUID,
        location,
        phoneNumber,
        message,
      });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async getTokenFromAuthentication({ requestUUID }) {
    try {
      const client = await api.getClient();
      return client.getAudkenniBearerToken(requestUUID);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default AuthService;
